import { render } from "./Annuario.vue?vue&type=template&id=fd66794e"
import script from "./Annuario.vue?vue&type=script&lang=js"
export * from "./Annuario.vue?vue&type=script&lang=js"

import "./Annuario.vue?vue&type=style&index=0&id=fd66794e&lang=css"

import exportComponent from "C:\\Users\\fr201\\Informatique\\annuario\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__